import { createSlice } from "@reduxjs/toolkit";


const membershipSlice = createSlice({
    name: "membership",
    initialState: {
      memberships: [],
      isPaid: false,
      total:0,
      checkoutId: null,
    },
    reducers: {
 

    updateTotal(state, action) {
      state.total = action.payload;
    },
    updateCheckoutId(state, action) {
      state.checkoutId = action.payload;
    },
    updateIsPaid(state, action) {
      state.isPaid = action.payload;
    }
    },
  });
export const { updateCheckoutId, updateIsPaid,updateTotal } = membershipSlice.actions;
export default membershipSlice.reducer;